import React from 'react';
import './Header.css';
import logo from '../../assets/images/enologica_logo1.svg'; 
import mainimg1 from '../../assets/images/mainimg1.png';
import grapeLogo from "../../assets/images/grapeLogo.svg";
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from '../../LanguageSwitcher';
import VideoPlayer from '../../Video/video';
import { Link } from 'react-router-dom';

const Header = () => {
  const { t, i18n } = useTranslation(); 
  const languageClass = i18n.language === 'ka' ? 'georgian' : 'english';

  return (
    <div className={`Mainhead ${languageClass}`}>
      <LanguageSwitcher id="sidebar" />
      <div className={`mainimg1 ${languageClass}`}>
        <div className={`wallpaper1 ${languageClass}`} style={{ backgroundImage: `url(${mainimg1})` }}>
          <div className={`logo-container ${languageClass}`}></div>
          <div className={`logo-title ${languageClass}`}>
            <Link  to='/' className={`logo ${languageClass}`}>
              <img src={logo} alt="Logo" />
            </Link>
            <div className={`logo-text ${languageClass}`}>
              <div>
                <img src={grapeLogo} alt="grapeLogo" />
                <h1>{t('Winery design')}</h1>
              </div>
              <div>
                <img src={grapeLogo} alt="grapeLogo" />
                <h1>{t('Machinery, tanks, devices')}</h1>
              </div>
              <div>
                <img src={grapeLogo} alt="grapeLogo" />
                <h1>{t('Tech assistance, service')}</h1>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className={`info-video ${languageClass}`}>
        <div className={`info ${languageClass}`}>
          <div className={`hundred ${languageClass}`}>
            <h1>100+</h1>
            <h3>{t('Successful projects in Georgia')}</h3>
          </div>
          <div className={`line ${languageClass}`}></div>
          <div>
            <div className={`dates1 ${languageClass}`}>
              <i>{t('From')}</i>
              <h1>1979</h1>
            </div>
            <h3>{t('Consulente enologica in Italy')}</h3>
          </div>
          <div className={`line ${languageClass}`}></div>
          <div>
            <div className={`dates1 ${languageClass}`}>
              <i>{t('From')}</i>
              <h1>2014</h1>
            </div>
            <h3>{t('Ce Enologica in Georgia')}</h3>
          </div>
        </div>

        <VideoPlayer className={`video-container ${languageClass}`} />
      </div>
    </div>
  );
};

export default Header;
